import { SelectOptionIcon } from 'Types';

export const socialList: SelectOptionIcon[] = [
	{
		value: 1,
		label: 'facebook',
		icon: 'facebook'
	},
	{
		value: 2,
		label: 'twitter',
		icon: 'twitter'
	},
	{
		value: 8,
		label: 'whatsapp',
		icon: 'whatsapp'
	},
	{
		value: 3,
		label: 'instagram',
		icon: 'instagram'
	},
	{
		value: 4,
		label: 'youtube',
		icon: 'youtube'
	},
	{
		value: 5,
		label: 'linkedin',
		icon: 'linkedin'
	},
	{
		value: 6,
		label: 'xing',
		icon: 'xing'
	},
	{
		value: 7,
		label: 'tiktok',
		icon: 'tiktok'
	}
];

